import request from "@/http";
const insertIdentificationData = (data) => {
  let { type_inner_app,mid_table_remark_001,mid_table_remark_002,mid_table_remark_003,mid_table_remark_004,mid_table_remark_005,mid_table_remark_014,mid_table_remark_016,id_public_middle_table,id_public_user_info, isloading = false } = data;
  return request.post({
    url: "duzikai_api_mgr_public_middle_table",
    data: {
      invoke_method: "public_insert_or_update_middle_table",
      pre_db_para_id_public_middle_table: id_public_middle_table,
      id_public_user_info: id_public_user_info,
      mid_table_remark_001: mid_table_remark_001,
      mid_table_remark_002: mid_table_remark_002,
      mid_table_remark_003: mid_table_remark_003,
      mid_table_remark_004: mid_table_remark_004,
      mid_table_remark_005: mid_table_remark_005,
      mid_table_remark_014: mid_table_remark_014,
      mid_table_remark_016: mid_table_remark_016,
      pre_db_para_middle_table_name: "public_middle_table_user_identification",
      type_middle_app: 2222,
      type_inner_app: type_inner_app?type_inner_app:5005,
      is_online: 0
    },
    loading: {
      enabled: isloading
    }
  })
}
const getIdentificationData = (data) => {
  let { type_inner_app,id_public_user_info,mid_table_remark_005, isloading = false } = data;
  return request.post({
    url: "duzikai_api_mgr_public_middle_table",
    data: {
      invoke_method: "public_load_middle_table_list",
      pre_db_para_middle_table_name: "public_middle_table_user_identification",
      pre_db_para_order_by_para: ' id_public_middle_table desc ',
      pre_db_para_begin_idx: 0,
      pre_db_para_length_4_list: 10,
      type_middle_app: 2222,
      type_inner_app_in: type_inner_app?type_inner_app:5005,
      is_online: 0,
      id_public_user_info: id_public_user_info,
      mid_table_remark_005: mid_table_remark_005
    },
    loading: {
      enabled: isloading
    }
  })
}
export default {
  insertIdentificationData,
  getIdentificationData
}
